var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-navigation-drawer",
    {
      staticClass: "ambience-details-panel",
      attrs: { app: "", temporary: "", right: "", width: _vm.drawerWidth },
      model: {
        value: _vm.drawer,
        callback: function ($$v) {
          _vm.drawer = $$v
        },
        expression: "drawer",
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "fill-height d-flex flex-column", attrs: { flat: "" } },
        [
          _c(
            "v-toolbar",
            {
              staticClass: "flex-grow-0",
              attrs: { flat: "", color: "grey lighten-4" },
            },
            [
              _c(
                "v-toolbar-title",
                { staticClass: "subtitle-1 font-weight-medium" },
                [
                  _c("v-icon", { attrs: { left: "", color: "primary" } }, [
                    _vm._v("mdi-door"),
                  ]),
                  _vm._v(" Detalhes da Sala "),
                ],
                1
              ),
              _c("v-spacer"),
              _c(
                "v-btn",
                { attrs: { icon: "" }, on: { click: _vm.close } },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              ),
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "div",
            { staticClass: "flex-grow-1 overflow-y-auto" },
            [
              _vm.loading
                ? [
                    _c("v-skeleton-loader", {
                      attrs: { type: "image, article, actions" },
                    }),
                  ]
                : _vm.ambience
                ? [
                    _vm.ambience.images && _vm.ambience.images.length
                      ? _c(
                          "v-carousel",
                          {
                            staticClass: "grey lighten-4",
                            attrs: {
                              height: "200",
                              "hide-delimiters": "",
                              "show-arrows-on-hover": "",
                            },
                          },
                          _vm._l(_vm.ambience.images, function (image, i) {
                            return _c("v-carousel-item", {
                              key: i,
                              attrs: { src: image.url, contain: "" },
                            })
                          }),
                          1
                        )
                      : _c(
                          "div",
                          {
                            staticClass:
                              "grey lighten-3 d-flex align-center justify-center",
                            staticStyle: { height: "200px" },
                          },
                          [
                            _c(
                              "v-icon",
                              {
                                attrs: { size: "64", color: "grey lighten-1" },
                              },
                              [_vm._v("mdi-image-off")]
                            ),
                          ],
                          1
                        ),
                    _c(
                      "v-card-text",
                      [
                        _c("div", { staticClass: "text-h6 mb-2" }, [
                          _vm._v(_vm._s(_vm.ambience.name)),
                        ]),
                        _vm.ambience.type
                          ? _c(
                              "v-chip",
                              {
                                staticClass: "mb-3",
                                attrs: {
                                  small: "",
                                  outlined: "",
                                  color: _vm.ambience.type.is_virtual
                                    ? "purple"
                                    : "blue",
                                },
                              },
                              [
                                _c(
                                  "v-icon",
                                  { attrs: { small: "", left: "" } },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.ambience.type.is_virtual
                                            ? "mdi-monitor-dashboard"
                                            : "mdi-door"
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                                _vm._v(
                                  " " + _vm._s(_vm.ambience.type.name) + " "
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c("v-divider", { staticClass: "my-3" }),
                        _c(
                          "div",
                          { staticClass: "subtitle-2 mb-2" },
                          [
                            _c(
                              "v-icon",
                              { attrs: { small: "", left: "", color: "grey" } },
                              [_vm._v("mdi-information")]
                            ),
                            _vm._v(" Informações Gerais "),
                          ],
                          1
                        ),
                        _c("v-simple-table", { attrs: { dense: "" } }, [
                          _c("tbody", [
                            _vm.ambience.code
                              ? _c("tr", [
                                  _c(
                                    "td",
                                    {
                                      staticClass: "caption grey--text",
                                      attrs: { width: "40%" },
                                    },
                                    [_vm._v("Código")]
                                  ),
                                  _c("td", { staticClass: "body-2" }, [
                                    _vm._v(_vm._s(_vm.ambience.code)),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm.ambience.block
                              ? _c("tr", [
                                  _c(
                                    "td",
                                    { staticClass: "caption grey--text" },
                                    [_vm._v("Bloco")]
                                  ),
                                  _c("td", { staticClass: "body-2" }, [
                                    _vm._v(_vm._s(_vm.ambience.block.name)),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm.ambience.floor
                              ? _c("tr", [
                                  _c(
                                    "td",
                                    { staticClass: "caption grey--text" },
                                    [_vm._v("Andar")]
                                  ),
                                  _c("td", { staticClass: "body-2" }, [
                                    _vm._v(_vm._s(_vm.ambience.floor.name)),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm.ambience.campus
                              ? _c("tr", [
                                  _c(
                                    "td",
                                    { staticClass: "caption grey--text" },
                                    [_vm._v("Campus")]
                                  ),
                                  _c("td", { staticClass: "body-2" }, [
                                    _vm._v(_vm._s(_vm.ambience.campus.name)),
                                  ]),
                                ])
                              : _vm._e(),
                          ]),
                        ]),
                        _c("v-divider", { staticClass: "my-3" }),
                        _c(
                          "div",
                          {
                            staticClass: "subtitle-2 mb-2 d-flex align-center",
                          },
                          [
                            _c(
                              "v-icon",
                              { attrs: { small: "", left: "", color: "grey" } },
                              [_vm._v("mdi-account-group")]
                            ),
                            _vm._v(" Capacidade "),
                            _vm.activeCapacityLabel
                              ? _c(
                                  "v-chip",
                                  {
                                    staticClass: "ml-2",
                                    attrs: {
                                      "x-small": "",
                                      color: "primary",
                                      dark: "",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " Modo ativo: " +
                                        _vm._s(_vm.activeCapacityLabel) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          { attrs: { dense: "" } },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "text-center",
                                attrs: { cols: "4" },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "capacity-cell",
                                    class: {
                                      "capacity-cell--active":
                                        _vm.ambience.capacity_mode === "RED",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "text-h5 purple--text" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.ambience.reduced_capacity || 0
                                          )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "caption grey--text" },
                                      [_vm._v("Reduzida")]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "text-center",
                                attrs: { cols: "4" },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "capacity-cell",
                                    class: {
                                      "capacity-cell--active":
                                        !_vm.ambience.capacity_mode ||
                                        _vm.ambience.capacity_mode === "CONV",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "text-h5 success--text" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.ambience.capacity || 0)
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "caption grey--text" },
                                      [_vm._v("Convencional")]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "text-center",
                                attrs: { cols: "4" },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "capacity-cell",
                                    class: {
                                      "capacity-cell--active":
                                        _vm.ambience.capacity_mode === "AMP",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "text-h5 primary--text" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.ambience.extended_capacity || 0
                                          )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "caption grey--text" },
                                      [_vm._v("Ampliada")]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm.occupation
                          ? _c("v-divider", { staticClass: "my-3" })
                          : _vm._e(),
                        _vm.occupation
                          ? [
                              _c(
                                "div",
                                { staticClass: "subtitle-2 mb-2" },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        small: "",
                                        left: "",
                                        color: "grey",
                                      },
                                    },
                                    [_vm._v("mdi-chart-bar")]
                                  ),
                                  _vm._v(" Ocupação Atual "),
                                ],
                                1
                              ),
                              _c("v-progress-linear", {
                                staticClass: "mb-2",
                                attrs: {
                                  value: _vm.occupationPercentage,
                                  color: _vm.occupationColor,
                                  height: "24",
                                  rounded: "",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function () {
                                        return [
                                          _c(
                                            "strong",
                                            { staticClass: "white--text" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.occupationPercentage
                                                ) + "%"
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  1080389378
                                ),
                              }),
                              _c(
                                "v-row",
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "6" } },
                                    [
                                      _c(
                                        "v-card",
                                        {
                                          staticClass: "pa-2 text-center",
                                          attrs: { outlined: "" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "text-h6" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.occupation.students || 0
                                                )
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "caption grey--text",
                                            },
                                            [_vm._v("Alunos Atuais")]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "6" } },
                                    [
                                      _c(
                                        "v-card",
                                        {
                                          staticClass: "pa-2 text-center",
                                          attrs: { outlined: "" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "text-h6" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.occupation.forecast || 0
                                                )
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "caption grey--text",
                                            },
                                            [_vm._v("Previsão")]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm.occupation.balance !== undefined
                                ? _c(
                                    "v-alert",
                                    {
                                      staticClass: "mt-3",
                                      attrs: {
                                        type:
                                          _vm.occupation.balance >= 0
                                            ? "success"
                                            : "error",
                                        dense: "",
                                        text: "",
                                      },
                                    },
                                    [
                                      _c("strong", [_vm._v("Saldo:")]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.occupation.balance > 0
                                              ? "+"
                                              : ""
                                          ) +
                                          _vm._s(_vm.occupation.balance) +
                                          " vagas "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          : _vm._e(),
                        _vm.ambience.resources && _vm.ambience.resources.length
                          ? _c("v-divider", { staticClass: "my-3" })
                          : _vm._e(),
                        _vm.ambience.resources && _vm.ambience.resources.length
                          ? [
                              _c(
                                "div",
                                { staticClass: "subtitle-2 mb-2" },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        small: "",
                                        left: "",
                                        color: "grey",
                                      },
                                    },
                                    [_vm._v("mdi-devices")]
                                  ),
                                  _vm._v(" Recursos Disponíveis "),
                                ],
                                1
                              ),
                              _c(
                                "v-chip-group",
                                { attrs: { column: "" } },
                                _vm._l(
                                  _vm.ambience.resources,
                                  function (resource) {
                                    return _c(
                                      "v-chip",
                                      {
                                        key: resource.id,
                                        attrs: { small: "", outlined: "" },
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { small: "", left: "" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                resource.icon || "mdi-check"
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(
                                          " " + _vm._s(resource.name) + " "
                                        ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                1
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]
                : [
                    _c(
                      "v-card-text",
                      { staticClass: "text-center py-8" },
                      [
                        _c(
                          "v-icon",
                          { attrs: { size: "64", color: "grey lighten-1" } },
                          [_vm._v("mdi-door-closed")]
                        ),
                        _c("div", { staticClass: "grey--text mt-2" }, [
                          _vm._v("Selecione uma sala para ver os detalhes"),
                        ]),
                      ],
                      1
                    ),
                  ],
            ],
            2
          ),
          _c("v-divider"),
          _c(
            "v-card-actions",
            { staticClass: "pa-3 flex-grow-0" },
            [
              _vm.ambience
                ? _c(
                    "v-btn",
                    {
                      attrs: { color: "orange", outlined: "", small: "" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("click:suggest-swap", _vm.ambience)
                        },
                      },
                    },
                    [
                      _c("v-icon", { attrs: { small: "", left: "" } }, [
                        _vm._v("mdi-swap-horizontal"),
                      ]),
                      _vm._v(" Sugerir Troca "),
                    ],
                    1
                  )
                : _vm._e(),
              _c("v-spacer"),
              _vm.ambience
                ? _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", small: "" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("click:edit", _vm.ambience)
                        },
                      },
                    },
                    [
                      _c("v-icon", { attrs: { small: "", left: "" } }, [
                        _vm._v("mdi-pencil"),
                      ]),
                      _vm._v(" Editar "),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }